/* Native details works without JS; enhance dismissal and keep the note in view. */
if (!customElements.get('pd2-policy-help')) {
  customElements.define('pd2-policy-help', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.controller) return;
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.panel = this.querySelector('.pd2-policies__popover');
      if (!this.details || !this.summary || !this.panel) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.details.addEventListener('toggle', () => this.sync(), options);
      this.querySelector('button').addEventListener('click', () => this.close(true), options);
      this.sync();
    }
    sync() {
      this.openController?.abort();
      cancelAnimationFrame(this.layoutFrame);
      if (!this.details.open) return;
      document.querySelectorAll('pd2-policy-help details[open]').forEach(details => {
        if (details !== this.details) details.open = false;
      });
      this.openController = new AbortController();
      const options = { signal: this.openController.signal };
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close(false);
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.close(true); }
      }, options);
      const schedule = () => {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => this.position());
      };
      window.addEventListener('resize', schedule, options);
      window.addEventListener('scroll', schedule, { ...options, capture: true, passive: true });
      this.position();
    }
    position() {
      if (!this.details.open) return;
      const anchor = this.closest('.pd2-policies__item') || this;
      const rect = anchor.getBoundingClientRect();
      const above = Math.max(0, rect.top - 12);
      const below = Math.max(0, innerHeight - rect.bottom - 12);
      this.panel.style.maxHeight = '';
      const height = Math.min(this.panel.scrollHeight, 360);
      if (below >= height) this.dataset.placement = 'below';
      else if (above >= height || above > below) this.dataset.placement = 'above';
      else this.dataset.placement = 'below';
      const available = this.dataset.placement === 'above' ? above : below;
      if (available < 120) {
        this.dataset.placement = 'center';
        this.panel.style.maxHeight = Math.max(80, innerHeight - 32) + 'px';
      } else {
        this.panel.style.maxHeight = Math.min(360, available) + 'px';
      }
    }
    close(restoreFocus) {
      this.details.open = false;
      this.openController?.abort();
      if (restoreFocus) this.summary.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.layoutFrame);
      this.openController?.abort();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
